module.exports = __webpack_public_path__ + "whitemind.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/whitemind.png
// module id = 896
// module chunks = 0